/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import RegularTemplate from '@/components/templates/RegularTemplate'
import { createCSVListingBatch, registerListingBatch } from '@/services/listing-batches'
import { useNavigate } from 'react-router-dom'
import { listMultipleAssetsUrls } from '@/configs/urls'
import ItemsSelectionMode from '@/components/batches/ItemsSelectionMode'
import {
  CREATE_ASSET_LISTING_BATCH,
  CREATE_ASSET_LISTING_BATCH_DESCRIPTION,
  RETURN_ASSETS_LISTING_BATCHES
} from '@/configs/strings/list-multiple-assets'
import { getAssets } from '@/services/assets'
import ItemBatchCreator from '@/components/forms/predefined/ItemBatchCreator'
import { setItemCustomProps, getItemsPropsForTable, tableColumns } from './handlers'
import { defaultFilterOptions, sortOptions } from '@/pages/Assets/pages/AssetList/components/ActionBar/handlers'
import HorizontalCardWithAddRemoveOptions from '@/components/cards/HorizontalCardWithAddRemoveOptions'
import UploadCsvForm from '@/components/batches/UploadCsvForm'

const RegisterListingBatch = () => {
  const [itemsSelectionMode, setItemsSelectionMode] = useState('uploadCsv')
  const navigate = useNavigate()
  const isUploadCsv = itemsSelectionMode === 'uploadCsv'
  const redirectToCurrentCreatedListingBatch = async (response) => {
    if (response?.id) {
      navigate(`/${listMultipleAssetsUrls.base}/${response.id}`, { replace: true })
    }
  }

  return (
    <RegularTemplate
      title={CREATE_ASSET_LISTING_BATCH}
      description={CREATE_ASSET_LISTING_BATCH_DESCRIPTION}
      backLabel={RETURN_ASSETS_LISTING_BATCHES}
      backUrl={`/${listMultipleAssetsUrls.base}`}
    >
      <ItemsSelectionMode
        className="mb-5 !w-64"
        onChange={setItemsSelectionMode}
      />
      { isUploadCsv
        ? <UploadCsvForm
            csvService={createCSVListingBatch}
            getResponse={redirectToCurrentCreatedListingBatch}
          />
        : <ItemBatchCreator
            baseUrl={listMultipleAssetsUrls.base}
            filterOptions={defaultFilterOptions}
            getItemsPropsForTable={getItemsPropsForTable}
            getItemsService={getAssets}
            itemComponent={HorizontalCardWithAddRemoveOptions}
            itemsKey="assets"
            registerBatchService={registerListingBatch}
            searchResultsKeyData="data"
            searchResultsKeyLabel="name"
            searchResultsKeyValue="name"
            setItemCustomProps={setItemCustomProps}
            sortOptions={sortOptions}
            tableColumns={tableColumns}
          />
      }
    </RegularTemplate>
  )
}

export default RegisterListingBatch
